var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { BaseService } from "./baseService";
class FileService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "file";
    }
    uploadFileToS3(fileType, body, s3Url) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = {
                "Content-Type": fileType,
            };
            yield axios.put(s3Url, body, { headers });
        });
    }
}
export const fileService = new FileService();
//# sourceMappingURL=fileService.js.map